import { Typography } from "@mui/material";
import React, { FC, useEffect, useState } from "react";

interface TextWithTimerProps {
  initialTime?: number;
  onTimerEnd?: () => void;
}

export const TextWithTimer: FC<TextWithTimerProps> = ({
  initialTime = 180000, // 3 minutes
  onTimerEnd,
}) => {
  const [timeLeft, setTimeLeft] = useState(initialTime);

  useEffect(() => {
    if (timeLeft <= 0 && initialTime > 0) {
      onTimerEnd?.();
    }
    if (timeLeft <= 0) return;

    const timerId = setInterval(() => {
      setTimeLeft((prevTime) => prevTime - 1000);
    }, 1000);

    return () => clearInterval(timerId);
  }, [timeLeft, onTimerEnd]);

  const minutes = Math.floor(timeLeft / 60000);
  const seconds = Math.floor((timeLeft % 60000) / 1000);

  return (
      <Typography variant="body1">
        Надіслати код повторно{" "}
        <Typography variant="body1" component={'span'} className="inline font-semibold">
          через: {minutes}:{seconds.toString().padStart(2, "0")}
        </Typography>
      </Typography>
  );
};
